module.exports = __webpack_public_path__ + "img/home-food-2.d0c39d6e.png";